import { GlobalState } from "../../../components/actions";

const systemPropertySelector = (state: GlobalState) => state.systemPropertyState;

export const SystemPropertyEntitySelector = (state: GlobalState) => systemPropertySelector(state).systemProperties;